import { BREAKPOINTS } from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';
import BpkButton, {
  BUTTON_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import BpkIconMap from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/map';
import BpkIconNewWindow from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/new-window';
import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';

import { useMBDContext } from '../common/MBD/useMBDContext';

import type { MapPreviewProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/MapPreviewProps';

import STYLES from './MapPreview.module.scss';

const MapPreview = ({
  ariaLabel,
  buttonLabel,
  googleStaticMapsUrl,
  googleStaticMapsUrlMobile,
  googleStaticMapsUrlTablet,
  redirectUrl,
  title,
}: MapPreviewProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  return (
    <div
      className={STYLES.MapPreview}
      data-testid="map-preview-section"
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      {title && (
        <div className={STYLES['MapPreview__section-header']}>
          <BpkSectionHeader title={title} />
        </div>
      )}
      <a
        className={STYLES.mapContainer}
        data-testid="map-link"
        tabIndex={0}
        aria-label={ariaLabel}
        href={redirectUrl}
        rel="nofollow"
      >
        <picture>
          <source
            media={BREAKPOINTS.MOBILE}
            srcSet={googleStaticMapsUrlMobile}
          />
          <source
            media={BREAKPOINTS.TABLET_ONLY}
            srcSet={googleStaticMapsUrlTablet}
          />
          <img
            className={STYLES.image}
            src={googleStaticMapsUrl}
            alt={ariaLabel}
          />
        </picture>

        <div className={STYLES.clickTarget}>
          <BpkButton
            data-test-id="show-map"
            className={STYLES.updatedButton}
            data-tracking-element-id={`${rawComponentName}_cta`}
            data-tracking-common-params={buildMBDParam(
              `${rawComponentName}_cta`,
              {
                cta_action: 'show_map',
              },
            )}
            type={BUTTON_TYPES.primaryOnLight}
          >
            <BpkIconMap className={STYLES.buttonMapIcon} />
            {buttonLabel}
            <BpkIconNewWindow className={STYLES.buttonNewWindowIcon} />
          </BpkButton>
        </div>
      </a>
    </div>
  );
};

export default MapPreview;
